import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { COLUMN_BMARK_TOTAL } from "shared/cubiq-services/model/BaseBmarkRiskTableDefinitionFactory";

const ONE_MILLION: CubiqTS.BigNumber = new CubiqTS.BigNumber(1000000);

export const METALS_DEFAULT_DISPLAY_MILLIONS = false; // metals are NOTIONAL

@Component({
  selector: "spot-risk-totals",
  templateUrl: "./bmark-spot-risk-totals.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BmarkSpotRiskTotalsRendererComponent implements ICellRendererAngularComp {
  /// DATA
  public params: any;
  public cell: any;
  //
  public property: string = null;
  public precision: number = 2;
  public materialSuffix: boolean = false;
  public displayInMillions: boolean = true;
  public displayEmpty: boolean = false;
  ///
  public amountNumber: number = null;
  public amountText: string = null;
  //
  public isNegative: boolean = false;
  public isZero: boolean = false;

  /**
   * BmarkSpotRiskTotalsRendererComponent is immutable after agInit() due to refresh() returning false
   *
   * Change from ag-grid will destroy component and create a new one
   *
   * A ChangeDetectorRef push (markForCheck) must never be called
   */
  constructor() {}

  public agInit(params: any): void {
    this.params = params;
    this.cell = { row: params.value, col: params.colDef.headerName };
    this.processParams(params);
  }

  public refresh(): boolean {
    return false;
  }

  protected processParams(params: any): void {
    if (params != null && params.data != null) {
      this.property = params.columnProperty;
      this.displayEmpty = typeof params.displayEmpty === "boolean" ? params.displayEmpty : false;
      //
      this.precision = typeof params.data.precision === "number" ? params.data.precision : 0;
      this.materialSuffix =
        typeof params.data.isMaterial === "boolean" ? params.data.isMaterial : false;
      this.displayInMillions = params.data.isMaterial
        ? METALS_DEFAULT_DISPLAY_MILLIONS
        : params.data.notation in CubiqTS.PositionUnit &&
          params.data.notation == CubiqTS.PositionUnit.Million;

      if (params.data[this.property] instanceof CubiqTS.BigNumber) {
        this.isZero =
          params.columnProperty !== COLUMN_BMARK_TOTAL &&
          (params.data[this.property] as CubiqTS.BigNumber).isEqualTo(0) &&
          (params.orderCountProperty == null || params.data[params.orderCountProperty] === 0); // added for OMS-31779
        this.amountNumber = params.data[this.property].toNumber();
        this.amountText = this.formatAmt(params.data[this.property], !this.isZero, params); //params.columnProperty === COLUMN_BMARK_TOTAL
        this.isNegative = (params.data[this.property] as CubiqTS.BigNumber).isLessThan(0);
      }
    } else {
      this.amountNumber = 0;
      this.amountText = "";
      this.isNegative = false;
      this.isZero = true;
    }
  }

  public formatAmt(value: CubiqTS.BigNumber, displayZero: boolean, params: any): string {
    let ret: string = displayZero ? new CubiqTS.BigNumber(0).toFormat(this.precision) : "";
    if (value instanceof CubiqTS.BigNumber && !value.isZero()) {
      if (this.displayInMillions) {
        // Millions
        ret = value.dividedBy(ONE_MILLION).toFormat(this.precision);
      } else {
        // Notional Amount
        ret = value.toFormat(this.precision);
      }
    }
    return ret;
  }
}
